import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@material-ui/core";
import dayjs from "dayjs";
import { SELECTED_BORDER, formatDollars, stripCategoryPrefix } from "./utils";

export default function TableChartView({ data, classes, selectedMonth, onSelect }) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Month</TableCell>
            <TableCell align="right">Charge Count</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell>Category Breakdown</TableCell>
            <TableCell>Forecast</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => {
            const isSelected = item.month === selectedMonth;
            return (
              <TableRow
                key={item.month}
                onClick={() => onSelect(item.month)}
                className={`${classes.monthRowClickable} ${isSelected ? classes.monthRowSelected : ""}`}
              >
                <TableCell>
                  <Typography
                    variant="body2"
                    style={isSelected ? { fontWeight: 700, color: SELECTED_BORDER } : {}}
                  >
                    {dayjs(item.month).format("MMM YYYY")}
                  </Typography>
                </TableCell>
                <TableCell align="right">{item.chargeCount}</TableCell>
                <TableCell align="right">
                  ${item.totalDollars || formatDollars(item.totalCents)}
                </TableCell>
                <TableCell>
                  {item.byCategory &&
                    Object.entries(item.byCategory).map(([category, catData]) => (
                      <Box key={category} display="flex" justifyContent="space-between" mb={0.5}>
                        <Typography variant="body2" style={{ marginRight: 16 }}>
                          {stripCategoryPrefix(category)}
                        </Typography>
                        <Typography variant="body2">
                          {catData.chargeCount} charges — ${formatDollars(catData.totalCents)}
                        </Typography>
                      </Box>
                    ))}
                </TableCell>
                <TableCell>
                  {item.forecast ? (
                    <Box>
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        ${item.forecast.unbilledTotalDollars || formatDollars(item.forecast.unbilledTotalCents)}
                        {" "}({item.forecast.unbilledChargeCount} charges)
                      </Typography>
                      {item.forecast.byCategory &&
                        Object.entries(item.forecast.byCategory).map(([category, catData]) => (
                          <Box key={category} display="flex" justifyContent="space-between" mb={0.5} mt={0.5}>
                            <Typography variant="caption" color="textSecondary" style={{ marginRight: 12 }}>
                              {stripCategoryPrefix(category)}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {catData.chargeCount} — ${formatDollars(catData.totalCents)}
                            </Typography>
                          </Box>
                        ))}
                    </Box>
                  ) : (
                    "—"
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
